import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from 'src/app/global/global';
import { Disorders } from 'src/app/models/disorders.model';
import { SetupRequest } from 'src/app/models/setup-request.model';
import { User } from 'src/app/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class DisordersService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getEnumDisorders() {
    return this.httpClient.get<Disorders[]>(Global.BASE_API_URL + "/api/disorders/all");
  }

  getAllUserDisorders() {
    return this.httpClient.get<string[]>(Global.BASE_API_URL + "/api/disorders");
  }

  saveDisorders(disorders: SetupRequest){
    return this.httpClient.put<string[]>(Global.BASE_API_URL + "/api/disorders", disorders);
  }

  saveSetup(setUp: SetupRequest) {
    return this.httpClient.put<User>(Global.BASE_API_URL + "/api/setup", setUp);
  }
}
